import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { redux } from '@ohif/core';
import Select from 'react-select';
import cornerstoneTools from 'cornerstone-tools';
import { TabFooter, useSnackbarContext, TablePagination } from '@ohif/ui';
import { useTranslation } from 'react-i18next';
import {
  getAiList,
  getLessonsTypeListByBasicSetting,
  getAiFilterSetting,
  addFilterSetting,
} from './makeData';
import './WindowLevelPreferences.styl';

import './LanguageSwitcher.styl';
// import { PageToolbar, TablePagination, useDebounce, useMedia } from '@ohif/ui';
// Contexts
import AppContext from '../../context/AppContext';

function AiResultFilterSetting({ onClose }) {
  const { appConfig = {} } = useContext(AppContext);
  const [dicCheckId, setDicCheckId] = useState(0);
  const [selectOptions, setSelectOptions] = useState([]);
  //过滤条件
  const [orderConditions, setOrderConditions] = useState([]);

  useEffect(() => {
    const fetchTableData = async () => {
      if (!selectOptions.length) {
        const data = await getLessonsTypeListByBasicSetting(appConfig);
        if (data) {
          if (!orderConditions.length) {
            if (data.data && data.data.length) {
              setOrderConditions(data.data[0].resultSettings);
            }
          }
          if (!selectOptions.length) {
            setSelectOptions(data.data);
          }

          if (!dicCheckId) {
            if (data.data && data.data.length) {
              setDicCheckId(data.data[0].aiBasicSettingId);
            }
          }
        }
      }

      if (dicCheckId) {
        const data = await getAiFilterSetting(dicCheckId, appConfig);
        if (data.data.length) {
          setFilterSettings(data.data);
          let a = data.data[0].p3.split(',');
          if (a.length && a[0] != '') {
            const test = [];
            a.forEach(data => {
              test.push({ projectName: data });
            });
            setOrderTable(test);
          } else {
            setOrderTable([]);
          }
        } else {
          setOrderTable([]);
        }
      }
    };
    fetchTableData();
  }, [appConfig, dicCheckId, orderConditions.length, selectOptions.length]);

  //排序列表
  const [orderTable, setOrderTable] = useState([]);

  //过滤条件设置列表
  const [filterSettings, setFilterSettings] = useState([]);

  const { t } = useTranslation('UserPreferencesModal');
  const onResetPreferences = () => {};
  const hasErrors = false;

  const snackbar = useSnackbarContext();

  const onChange = event => {
    const { value } = event.target;
    for (let i = 0; i < selectOptions.length; i++) {
      if (selectOptions[i].aiBasicSettingId == value) {
        setOrderConditions(selectOptions[i].resultSettings);
      }
    }
    setDicCheckId(value);
  };

  return (
    <React.Fragment>
      <div
        style={{
          marginLeft: '20px',
          marginTop: '20px',
          display: 'inlineBlock',
        }}
        className="WindowLevelPreferences"
      ></div>

      <div className="WindowLevelPreferences">
        <div className="wlColumn">
          <div>
            <select
              name="language-select"
              id="language-select"
              className="language-select"
              value={dicCheckId}
              onChange={onChange}
              style={{
                marginTop: '10px',
                marginLeft: '-300px',
              }}
            >
              {selectOptions.length
                ? selectOptions.map((lng, i) => (
                    <option
                      key={lng.aiBasicSettingId + i}
                      value={lng.aiBasicSettingId}
                    >
                      {lng.lessonsName}
                    </option>
                  ))
                : null}
            </select>

            <button
              style={{
                float: 'right',
                height: '40px',
                marginTop: '10px',
                marginBottom: '10px',
              }}
              onClick={() => {
                if (!orderTable || !orderTable.length) {
                  const data = [];
                  const selected = { projectName: '' };
                  data.push(selected);
                  setOrderTable(data);
                } else {
                  const data = Object.assign([], orderTable);
                  const selected = { projectName: '' };
                  data.push(selected);
                  setOrderTable(data);
                }
              }}
            >
              新增
            </button>
          </div>
          <div className="wlRow header">
            <div className="wlColumn description">序号</div>
            <div className="wlColumn description">排序条件</div>
          </div>

          {orderTable &&
            Object.keys(orderTable).map((key, index) => {
              return (
                <div className="wlRow" key={key}>
                  <div className="wlColumn description">
                    <div className="preferencesInput">{parseInt(key) + 1}</div>
                  </div>
                  <div className="wlColumn description">
                    <select
                      className="preferencesInput"
                      value={orderTable[key].projectName}
                      onChange={event => {
                        const { value } = event.target;
                        const filterSetting = Object.assign([], orderTable);
                        filterSetting[key].projectName = value;
                        setOrderTable(filterSetting);
                      }}
                      style={{
                        height: '40px',
                        marginLeft: '20px',
                      }}
                    >
                      {orderConditions && orderConditions.length
                        ? orderConditions.map(lng => (
                            <option
                              key={lng.projectName}
                              value={lng.projectName}
                            >
                              {lng.projectName}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      <div className="WindowLevelPreferences">
        <div className="wlColumn">
          <div>
            <button
              style={{
                float: 'right',
                height: '40px',
                marginTop: '10px',
                marginBottom: '10px',
              }}
              onClick={() => {
                if (!filterSettings && filterSettings.length) {
                  const data = [
                    {
                      projectName: '',
                      type: 1,
                      conditions: '',
                      p1: '',
                      p2: '0',
                      p4: '',
                    },
                  ];
                  setFilterSettings(data);
                } else {
                  const data = Object.assign([], filterSettings);
                  data.push({
                    projectName: '',
                    type: 1,
                    conditions: '',
                    p1: '',
                    p2: '0',
                    p4: '',
                  });
                  setFilterSettings(data);
                }
              }}
            >
              新增
            </button>
          </div>
          <div className="wlRow header">
            <div className="wlColumn preset">序号</div>
            <div className="wlColumn description">列</div>
            <div className="wlColumn description">筛选形式</div>
            <div className="wlColumn description">筛选条件</div>
            <div className="wlColumn description">表述</div>
            <div className="wlColumn description">启停用</div>
          </div>

          {filterSettings &&
            Object.keys(filterSettings).map((key, index) => {
              return (
                <div className="wlRow" key={key}>
                  <div className="wlColumn preset">{parseInt(key) + 1}</div>

                  <div className="wlColumn description">
                    <select
                      className="preferencesInput"
                      value={filterSettings[key].projectName}
                      onChange={event => {
                        const { value } = event.target;
                        const filterSetting = Object.assign([], filterSettings);
                        filterSettings[key].projectName = value;

                        let code = '';
                        for (let i = 0; i < orderConditions.length; i++) {
                          if (orderConditions[i].projectName == value) {
                            code = orderConditions[i].projectCode;
                            filterSettings[key].p4 = code;
                          }
                        }
                        setFilterSettings(filterSetting);
                      }}
                      style={{
                        height: '40px',
                      }}
                    >
                      {orderConditions && orderConditions.length
                        ? orderConditions.map(lng => (
                            <option
                              key={lng.projectName}
                              value={lng.projectName}
                            >
                              {lng.projectName}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>

                  <div className="wlColumn description">
                    <select
                      className="preferencesInput"
                      value={filterSettings[key].type}
                      onChange={event => {
                        const { value } = event.target;
                        const filterSetting = Object.assign([], filterSettings);
                        filterSettings[key].type = value ? value : 3;
                        setFilterSettings(filterSetting);
                      }}
                      style={{
                        height: '40px',
                      }}
                    >
                      <option key={3} value={3}>
                        {'等于（=）'}
                      </option>
                      <option key={2} value={2}>
                        {'小于等于（<=）'}
                      </option>
                      <option key={1} value={1}>
                        {'大于等于（>=）'}
                      </option>
                      <option disabled={true} key={0} value={0}>
                        {'匹配（模糊查询）'}
                      </option>
                    </select>
                  </div>

                  <div className="wlColumn description">
                    <input
                      type="text"
                      className="preferencesInput"
                      value={filterSettings[key].conditions}
                      data-key={key}
                      data-inputname="description"
                      disabled={
                        filterSettings[key].type == 0 ||
                        filterSettings[key].type == 3
                      }
                      onChange={event => {
                        const { value } = event.target;
                        const filterSetting = Object.assign([], filterSettings);
                        filterSettings[key].conditions = value;
                        setFilterSettings(filterSetting);
                      }}
                    />
                  </div>

                  <div className="wlColumn description">
                    <input
                      type="text"
                      className="preferencesInput"
                      value={filterSettings[key].p1}
                      data-key={key}
                      data-inputname="description"
                      disabled={
                        filterSettings[key].type == 0 ||
                        filterSettings[key].type == 3
                      }
                      onChange={event => {
                        const { value } = event.target;
                        const filterSetting = Object.assign([], filterSettings);
                        filterSettings[key].p1 = value;
                        setFilterSettings(filterSetting);
                      }}
                    />
                  </div>

                  <div className="wlColumn description">
                    <button
                      className="preferencesInput"
                      onClick={() => {
                        const filterSetting = Object.assign([], filterSettings);
                        filterSettings[key].p2 =
                          filterSettings[key].p2 == '1' ? '0' : '1';
                        setFilterSettings(filterSetting);
                      }}
                    >
                      {filterSettings[key].p2 == '0' ? '启用' : '停用'}
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      <TabFooter
        onResetPreferences={onResetPreferences}
        onSave={() => {
          const data = Object.assign([], filterSettings);
          const orders = Object.assign([], orderTable);
          let orderArr = [];
          orders.forEach(data => {
            orderArr.push(data.projectName);
          });
          let p3 = orderArr.join(',');
          data.forEach(data => {
            data.p3 = p3;
            data.aiBasicSettingId = dicCheckId;
          });
          let payload = {
            aiFilter: data,
            orders: JSON.stringify(orders),
          };
          addFilterSetting(payload).then(data => {
            console.log(data);
            if (data.id) {
              snackbar.show({
                message: '过滤设置更新成功',
                type: 'success',
              });
            } else {
              snackbar.show({
                message: '过滤设置保存成功',
                type: 'success',
              });
            }
          });
        }}
        onCancel={onClose}
        hasErrors={hasErrors}
        t={t}
      />
    </React.Fragment>
  );
}

AiResultFilterSetting.propTypes = {
  onClose: PropTypes.func,
};

export { AiResultFilterSetting };
